import { getCookie } from '@pb/utils'

const getUserHasIncompleteProfile = (): any => {
  const clubFullJoinCookie = getCookie('clubFullJoinCookie')
  const userHasIncompleteProfile =
    clubFullJoinCookie && clubFullJoinCookie.includes('"status":"-1"')
  return userHasIncompleteProfile
}

export default getUserHasIncompleteProfile
